import { useState, useEffect } from 'react'
import Time from './Time'
import './News.scss'

const News = () => {
  const [news, setNews] = useState({})
  const [updatedNews, setUpdatedNews] = useState(null)

  useEffect(() => {
    //fetch('http://localhost:3000/bbcnews.json', { mode: 'no-cors' })
    fetch('https://api.inscreen.it/bbcnews')
      .then((response) => response.json())
      .then((data) => {
        setNews(data)
      })
      .catch((err) => console.log('There was an error accessing the API', err))
  }, [])

  useEffect(() => {
    let interval = 0

    interval = setInterval(() => {
      fetch('https://api.inscreen.it/bbcnews')
        .then((response) => response.json())
        .then((data) => {
          setUpdatedNews(data)
        })
        .then(() => {
          if (updatedNews !== null) {
            if (JSON.stringify(news) !== JSON.stringify(updatedNews)) {
              setNews(updatedNews)
            }
          }
        })
        .catch((err) =>
          console.log('There was an error accessing the API', err)
        )
    }, 20000)

    return () => clearInterval(interval)
  })

  useEffect(() => {
    let interval = 0
    let current = 0
    const slides = document.getElementsByTagName('li')

    interval = setInterval(() => {
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.opacity = 0
      }
      current = current !== slides.length - 1 ? current + 1 : 0
      slides[current].style.opacity = 1
    }, 8000)

    return () => clearInterval(interval)
  }, [news])

  if (!news.items) {
    return null
  }

  return (
    <div className='banner news-banner'>
      <div className='news-banner-title'>News</div>
      <div className='news-banner-headlines'>
        <span>Latest:</span>

        <ul className='headlines-list'>
          {news.items.map((headline) => (
            <li key={headline.id} className='headlines-list-item'>
              {headline.title}
            </li>
          ))}
        </ul>
      </div>
      <div className='time'>
        <Time />
      </div>
    </div>
  )
}

export default News
